export const useCategoryTrialContentItemInfos = (
  categoryTrialContent: UseCategoryTrialContent,
  content: IContentSchema,
  isLocked: boolean
) => {
  const { getTrialType, progressions, isTrialAvailableForTypeAndContentId } =
    categoryTrialContent;

  const trialType = computed(() => {
    return getTrialType(content.lockedContent || content.contentType);
  });

  const trialIds = computed(() => {
    const ids = progressions.value
      .filter((pr) => pr.type === `trialContent_${trialType.value}`)
      .map((pr) => pr.contentId);
    return ids;
  });

  const isTrialAvailable = computed<boolean>(() => {
    return isTrialAvailableForTypeAndContentId({
      id: content.id,
      lockedContent: content.lockedContent || content.contentType,
    });
  });

  const isTrialItem = computed(() => {
    if (!isLocked) return false;
    if (!trialType.value) return false;

    return trialIds.value.includes(content.id);
  });

  const isATrialType = computed(() => trialType.value !== null);

  return {
    trialType,
    isTrialItem,
    isATrialType,
    isTrialAvailable,
  };
};
